import EventApi from '@/api/event';

const GiftSubEventApi = {
  /**
   * 경품 응모 대상 체크 api
   * @return {Promise<void>}
   */
  checkEventUser: async () => {
    try {
      const response = await EventApi.post(
        '/adventure_subscription_gift_api.php',
      );
      return response;
    } catch (e) {
      return e.response;
    }
  },
};
export default GiftSubEventApi;
